export default __webpack_public_path__ + "static/media/474.15fbb735.png";